<template>
    <div class="products-wrapper">
        <app-header></app-header>
        <div class="products-content">
            <app-aside></app-aside>
            <app-specs></app-specs>
        </div>
    </div>
</template>

<script>
import Header from "./products/Header";
import Aside from "./products/Aside";
import Specification from "./products/Specification";
export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appSpecs: Specification
  }
};
</script>

<style scoped>
.products-content {
  display: flex;
  padding: 20px 0 80px;
}
@media screen and (max-width: 1000px) {
  .products-content {
    padding-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue